module.exports = __webpack_public_path__ + "img/category_seasons__and__holidays.8d41513.png";